import { useEffect, useRef, useState } from 'react';
import config from '../../constants/config.js';
import './../../styles/Dashboard.css';
import { useToast } from '../../context/ToastProvider.js';

function TemplatesTable({
    templates,
    loading,
    onUpdate
}) {
    const [ openMenuIndex, setOpenMenuIndex ] = useState( null );
    const [ disableActions , setDisableActions ] = useState( false );

    const menuRefs = useRef( [] );
    const addToast = useToast();

    function toggleMenu( index ) {
        setOpenMenuIndex( ( prevIndex ) => ( prevIndex === index ? null : index ) );
    }

    async function removeTemplate( symbolId , menuIndex ) {
        setDisableActions( true );
        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/templates/${encodeURIComponent(symbolId)}`;
            const requestSettings = {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            };

            const response = await fetch( url , requestSettings );
            addToast( `Succesfully removed the template`, false , 5000 );
            toggleMenu( menuIndex );

            if ( typeof ( onUpdate ) === 'function' ) {
                onUpdate();
            }
        } catch ( error ) {
            console.log( error );
        } finally {
            setDisableActions( false )
        }
    }

    function formatTimeAgo( timestamp ) {
        const now = new Date();
        const lastModified = new Date(timestamp);
        
        if ( isNaN( lastModified.getTime() ) ) {
            return "NEVER";
        }

        const diffInSeconds = Math.floor((now - lastModified) / 1000);
    
        if (diffInSeconds < 60) {
            return `${diffInSeconds} sec(s) ago`;
        } else if (diffInSeconds < 3600) {
            return `${Math.floor(diffInSeconds / 60)} min(s) ago`;
        } else if (diffInSeconds < 86400) {
            return `${Math.floor(diffInSeconds / 3600)} hour(s) ago`;
        } else if (diffInSeconds < 432000) {
            return `${Math.floor(diffInSeconds / 86400)} day(s) ago`;
        } else {
            return lastModified.toLocaleDateString();
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if ( openMenuIndex !== null && menuRefs.current[openMenuIndex] && 
                !menuRefs.current[ openMenuIndex ].contains(event.target)) {
                setOpenMenuIndex(null);
            }
        }

        if ( openMenuIndex !== null ) {
            document.addEventListener( "mousedown", handleClickOutside );
        }

        return () => {
            document.removeEventListener( "mousedown", handleClickOutside );
        };
    }, [ openMenuIndex ] );

    if ( loading ) {
        return(
            <div className="product-table-skeleton"></div>
        )
    }

    return( 
        <div>
            <div className="dashboard-table">
                <table id="recent-products">
                    <thead>
                        <tr>
                            <th>TEMPLATE NAME</th>
                            <th>TEMPLATE CATEGORY</th>
                            <th>CREATED AT</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                            templates?.length > 0 ? 
                                templates?.map( ( row , index ) => {
                                    return(
                                        <tr className="product-row" key={ index }>
                                            <td>
                                                <div className="product-details">
                                                    <div className="product-title">
                                                        {row?.name}
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="type normal">
                                                    { row?.category || "" }
                                                </div>
                                            </td>

                                            <td>
                                                <div className="last-editor normal">
                                                    { formatTimeAgo( row?.timestamp ) }
                                                </div>
                                            </td>
                                            
                                            <td>
                                                <div className="actions" ref={(el) => menuRefs.current[index] = el}>
                                                    <button className="more-options" onClick={() => toggleMenu( index )}>
                                                        ...
                                                    </button>

                                                    { openMenuIndex === index && (
                                                        <ul className="options-menu">
                                                            <li className="option-menu-li">
                                                                <button disabled={disableActions} className="option-action" onClick={ () => removeTemplate( row.id , index ) }>
                                                                    Remove
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr>
                                <td colSpan="4">No Templates Found</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default TemplatesTable;